import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import FaqAccordion from '../../components/FaqAccordion';
import PublicMarketingChrome from '../../components/PublicMarketingChrome';
import { APP_NAME } from '../../constants';

const FaqPage = () => {
  const navigate = useNavigate();

  return (
    <PublicMarketingChrome
      helmetTitle={`FAQ — ${APP_NAME}`}
      description={`Questions fréquentes ${APP_NAME} : urgences, prix, devis, garanties, commande et annulation.`}
      kicker="Aide"
      title="Questions fréquentes"
      subtitle="Prix, urgences, garanties — les réponses avant de commander."
    >
      <FaqAccordion />
      <div className="text-center mt-10">
        <Button
          variant="default"
          size="lg"
          iconName="Calendar"
          onClick={() => navigate('/service-booking-wizard')}
        >
          Réserver une intervention
        </Button>
      </div>
    </PublicMarketingChrome>
  );
};

export default FaqPage;
